// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__1VVtW","colCheckbox":"styles_colCheckbox__2qJZy"};